import { createLucideIcon } from "lucide-react";

export const PencilEdit = createLucideIcon(
    "PencilEdit",
    [
        [
            "path",
            {
                d: "M16.2141 4.9824L10.9802 10.2163C9.9349 11.2616 9.4123 11.7842 9.0564 12.4211C8.7005 13.058 8.3424 14.5619 8 16C9.4381 15.6576 10.942 15.2995 11.5789 14.9436C12.2158 14.5877 12.7384 14.0651 13.7837 13.0198L19.0176 7.7859",
                key: "1ohcxn",
            },
        ],
        [
            "path",
            {
                d: "M16.2141 4.9824L17.6158 3.5806C18.39 2.8065 19.6452 2.8065 20.4194 3.5806C21.1935 4.3548 21.1935 5.61 20.4194 6.3842L19.0176 7.7859",
                key: "mw0u98",
            },
        ],
        [
            "path",
            {
                d: "M16.2141 4.9824L19.0176 7.7859",
                key: "9obigl",
            },
        ],
        [
            "path",
            {
                d: "M21 12C21 16.2426 21 18.364 19.682 19.682C18.364 21 16.2426 21 12 21C7.75736 21 5.63604 21 4.31802 19.682C3 18.364 3 16.2426 3 12C3 7.75736 3 5.63604 4.31802 4.31802C5.63604 3 7.75736 3 12 3",
                key: "py4y6v",
            },
        ],
    ],
);
